namespace Ir.Components.ReportDesigner.ExpressionEditor {

    let popupControl: DevExpress.ui.dxPopup = null;
    let metricField: MetricField;
    let metricArray: KnockoutObservableArray<MetricField>;
    let groupingTypeOptions: KnockoutObservableArray<any> = ko.observableArray();
    let reportDesigner: Ir.Components.ReportDesigner.ReportDesigner.IViewModel;

    export function show(pMetricField: MetricField, pMetricArray: KnockoutObservable<KnockoutObservableArray<MetricField>>, pGroupingTypeOptions: Array<any>, pReportDesigner: Ir.Components.ReportDesigner.ReportDesigner.IViewModel) {
        metricField = pMetricField;
        metricArray = pMetricArray();
        groupingTypeOptions(pGroupingTypeOptions);
        reportDesigner = pReportDesigner;

        if (popupControl == null) {
            let $popover = $(`<expression-editor></expression-editor>`);
            $popover.appendTo('body');
            ko.applyBindings({ }, $popover[0]);
        }
        else {
            popupControl.show();
        }
    }

    interface IViewModel {
        popupOptions: DevExpress.ui.dxPopup.Properties;

        availableFields: KnockoutObservable<any>;
        name: KnockoutObservable<string>;
        groupingType: KnockoutObservable<GroupingTypeEnum>;
        calculateTotals: KnockoutObservable<CalculateTotalsEnum>;
        formulaTop: KnockoutObservable<string>;
        formulaBottom: KnockoutObservable<string>;
        errorMessage: KnockoutObservable<string>;
        fieldListOptions: DevExpress.ui.dxTreeView.Properties;
        nameTextBoxOptions: DevExpress.ui.dxTextBox.Properties;
        groupingTypeTextBoxOptions: DevExpress.ui.dxSelectBox.Properties;
        calculateTotalsTextBoxOptions: DevExpress.ui.dxSelectBox.Properties;
        topFormulaTextAreaOptions: DevExpress.ui.dxTextArea.Properties;
        bottomFormulaTextAreaOptions: DevExpress.ui.dxTextArea.Properties;
        errorTextAreaOptions: DevExpress.ui.dxTextArea.Properties;
    }

    interface IParams {
    }

    export function getViewModel(this: IViewModel, params: IParams, componentInfo) {
        let self = this;
        if ((params as any).config) {
            params = (params as any).config;
        }

        let treeView: DevExpress.ui.dxTreeView;

        self.popupOptions = {
            width: 730,
            height: 480,
            title: "Expression Editor",
            visible: true,
            onShowing(e) {
                self.availableFields(Ir.Components.ReportDesigner.ReportDesigner.getAvailableFieldsForExpression(reportDesigner));

                let translatedFormulaTop = translateFormula(self, metricField.metricContainer.metricExpression.formulaTop);
                let translatedFormulaBottom = translateFormula(self, metricField.metricContainer.metricExpression.formulaBottom);

                self.name(metricField.displayNameForDesigner());
                self.groupingType(metricField.groupingType());
                self.calculateTotals(metricField.calculateTotals());
                self.formulaTop(translatedFormulaTop);
                self.formulaBottom(translatedFormulaBottom);
                self.errorMessage("");

                e.component.option("title", "Expression: " + self.name());
                formulaBottomTextArea.option("disabled", self.groupingType() !== GroupingTypeEnum.WDSUM);

                //Create a new simple array, because visible conflicts with the treeview
                let fields = self.availableFields();
                let items = [];
                for (const field of fields) {
                    items.push({
                        queryName: field.queryName,
                        displayNameForExpression: field.displayNameForExpression,
                        function: null,
                    });
                }

                treeView.option("items", [
                    {
                        id: "A",
                        displayNameForExpression: "Metrics",
                        items: items,
                        expanded: true,
                    },
                    {
                        id: "B",
                        displayNameForExpression: "Functions",
                        items: [
                            {
                                displayNameForExpression: "IIF(condition, trueValue, falseValue)",
                                function: "IIF(A = B, trueValue, falseValue)",
                                queryName: "IIF",
                            },
                            {
                                displayNameForExpression: "ISNULL(value, nullValue)",
                                function: "ISNULL(value, nullValue)",
                                queryName: "ISNULL",
                            },
                        ],
                        expanded: true,
                    }
                ]);
            },
            onInitialized(e) {
                popupControl = e.component;
            },
            toolbarItems: [
                {
                    widget: 'dxButton',
                    toolbar: 'bottom',
                    location: 'after',
                    options: {
                        icon: 'save',
                        stylingMode: 'contained',
                        type: 'default',
                        text: 'Save',
                        onClick() {
                            if (self.errorMessage()) {
                                DevExpress.ui.notify({
                                    message: "Formula is invalid. Please check the errors.",
                                    width: 300,
                                    position: {
                                        of: "#metric-expression-error",
                                        at: 'center bottom',
                                    }
                                }, 'error', 3000);
                                return;
                            }

                            let formulaTop = self.formulaTop();

                            if (!formulaTop) {
                                DevExpress.ui.notify({
                                    message: "Formula is empty.\nPlease enter a formula.",
                                    width: 200,
                                    position: {
                                        of: "#metric-expression-top-formula"
                                    }
                                }, 'warning', 3000);
                                return;
                            }

                            let groupingType = self.groupingType();
                            let formulaBottom = "";

                            if (groupingType === GroupingTypeEnum.WDSUM) {
                                formulaBottom = self.formulaBottom();

                                if (!formulaBottom) {
                                    DevExpress.ui.notify({
                                        message: "Formula is empty.\nPlease enter a formula.",
                                        width: 200,
                                        position: {
                                            of: "#metric-expression-bottom-formula"
                                        }
                                    }, 'warning', 3000);
                                    return;
                                }
                            }

                            let replaceNamesToQueryName = function (formula) {
                                const matches = formula.matchAll(Ir.Components.ReportDesigner.ReportDesigner.regexExpressionFormulaNames);

                                for (const match of matches) {
                                    let name = match.groups.name;
                                    let fieldExpression = self.availableFields().find(x => x.displayNameForExpression === name);
                                    let metricName = `[${fieldExpression.queryName}]`;
                                    formula = formula.replace(match[0], metricName);
                                }

                                return formula;
                            };

                            formulaTop = replaceNamesToQueryName(formulaTop);
                            formulaBottom = replaceNamesToQueryName(formulaBottom);

                            metricField.displayNameForDesigner(self.name());
                            metricField.groupingType(self.groupingType());
                            metricField.metricContainer.metricExpression.groupingType = self.groupingType();
                            metricField.calculateTotals(self.calculateTotals());
                            metricField.metricContainer.metricExpression.formulaTop = formulaTop;
                            metricField.metricContainer.metricExpression.formulaBottom = formulaBottom;
                            popupControl.hide();
                            Ir.Components.ReportDesigner.ReportDesigner.validateFieldsForExpression(reportDesigner);
                        },
                    },
                }, 
                {
                    widget: 'dxButton',
                    toolbar: 'bottom',
                    location: 'after',
                    options: {
                        icon: "close",
                        text: 'Close',
                        stylingMode: 'outlined',
                        type: 'normal',
                        onClick() {
                            popupControl.hide();
                        },
                    },
                }
            ],
        };
        
        self.availableFields = ko.observableArray();
        self.name = ko.observable("");
        self.groupingType = ko.observable();
        self.calculateTotals = ko.observable();
        self.formulaTop = ko.observable("");
        self.formulaBottom = ko.observable("");
        self.errorMessage = ko.observable("");

        let clickTimeout: NodeJS.Timeout;
        let lastFormulaFocus = "Top";
        let formulaTopTextArea: DevExpress.ui.dxTextArea;
        let formulaBottomTextArea: DevExpress.ui.dxTextArea;
        self.fieldListOptions = {
            width: 300,
            height: 370,
            keyExpr: "id",
            displayExpr: "displayNameForExpression",
            items: [],
            itemsExpr: "items",
            expandedExpr: "expanded",
            searchEnabled: true,
            onInitialized(e) {
                treeView = e.component;
            },
            onItemClick: function (e) {
                let options = self.fieldListOptions;
                let item = e.itemData;

                if (!clickTimeout) {
                    clickTimeout = setTimeout(function () {
                        clickTimeout = null;
                    }, 300);
                }
                else if (item === options.selectedItem && item.queryName) {
                    let lastTarget = lastFormulaFocus === "Top" ? ($("#top-formula-expression-input") as any) : ($("#bottom-formula-expression-input") as any);

                    let end = 0;
                    let value;
                    if (!item.function) {
                        value = `[${item.displayNameForExpression}]`;
                    }
                    else {
                        value = item.function;
                    }

                    if (lastTarget === null) {
                        //lastTarget = document.getElementById("TopFormula");
                        //let value = $(lastTarget).val();

                        //if (value === "") {
                        //    $(lastTarget).val(expression);
                        //} else {
                        //    $(lastTarget).val(`${value} ${expression}`);
                        //}

                        //$(lastTarget).putCursorAtEnd();
                    } else {
                        end = lastTarget.caret().end;

                        if (value != "") {
                            let i = lastTarget.caret().begin;
                            let j = lastTarget.caret().end;

                            let b = lastTarget.val().substring(0, i);
                            let a = lastTarget.val().substring(j);

                            let newFormula = `${b} ${value} ${a} `.trimStart();
                            if (lastFormulaFocus === "Top") {
                                self.formulaTop(newFormula);
                            }
                            else {
                                self.formulaBottom(newFormula);
                            }
                        }
                    }

                    if (lastFormulaFocus === "Top") {
                        formulaTopTextArea.focus();
                    }
                    else {
                        formulaBottomTextArea.focus();
                    }

                    if (lastTarget)
                        lastTarget.caretTo(end + value.length + 1);
                }

                options.selectedItem = item;
            },
        };

        self.nameTextBoxOptions = {
            value: self.name as any,
            width: '100%',
            label: 'Name',
            labelMode: "floating",
        };

        self.groupingTypeTextBoxOptions = {
            value: self.groupingType,
            width: '100%',
            label: 'Operation',
            labelMode: "floating",
            items: groupingTypeOptions as any,
            displayExpr: 'text',
            valueExpr: 'value',
            onValueChanged(e) {
                let errorMessage = Ir.Components.ReportDesigner.ReportDesigner.validateFormulaForExpression(reportDesigner, self.formulaTop(), self.formulaBottom(), self.groupingType());
                self.errorMessage(errorMessage);
                if (self.groupingType() === GroupingTypeEnum.DSUM) {
                    self.formulaBottom("");
                }
            },
        };

        self.calculateTotalsTextBoxOptions = {
            value: self.calculateTotals,
            dataSource: [{ value: 0, text: 'Use Formula' }, { value: 1, text: 'Sum Rows' }],
            displayExpr: 'text',
            valueExpr: 'value',
            width: '100%',
            label: 'Totals',
            labelMode: "floating",
        };

        self.topFormulaTextAreaOptions = {
            value: self.formulaTop as any,
            label: "Formula Top",
            labelMode: "floating",
            width: 400,
            height: 90,
            inputAttr: {
                id: 'top-formula-expression-input',
            },
            onValueChanged(e) {
                let errorMessage = Ir.Components.ReportDesigner.ReportDesigner.validateFormulaForExpression(reportDesigner, self.formulaTop(), self.formulaBottom(), self.groupingType());
                self.errorMessage(errorMessage);
            },
            onFocusIn(e) {
                lastFormulaFocus = "Top";
            },
            onInitialized(e) {
                formulaTopTextArea = e.component;
            },
        };

        self.bottomFormulaTextAreaOptions = {
            value: self.formulaBottom as any,
            label: "Formula Bottom",
            labelMode: "floating",
            width: 400,
            height: 90,
            inputAttr: {
                id: 'bottom-formula-expression-input',
            },
            disabled: ko.computed(function () {
                return self.groupingType() !== GroupingTypeEnum.WDSUM;
            }) as any,
            onValueChanged: function (e) {
                let errorMessage = Ir.Components.ReportDesigner.ReportDesigner.validateFormulaForExpression(reportDesigner, self.formulaTop(), self.formulaBottom(), self.groupingType());
                self.errorMessage(errorMessage);
            },
            onFocusIn: function () {
                lastFormulaFocus = "Bottom";
            },
            onInitialized(e) {
                formulaBottomTextArea = e.component;
            },
        };

        self.errorTextAreaOptions = {
            value: self.errorMessage as any,
            autoResizeEnabled: true,
            width: 400,
            height: 60,
            readOnly: true,
            inputAttr: {
                style: "color:#a70606",
            },
        };

        let onChanged = function () {
            var validation = validateDesigner(self);

            //if (!validation.isValid) {
            //    DevExpress.ui.notify({
            //        message: "This design is not valid. " + validation.invalidMessage,
            //        position: {
            //            my: 'center top',
            //            at: 'center top',
            //        },
            //    }, 'success', 3000);
            //    return;
            //}
        };
    }

    function translateFormula(self: IViewModel, formula: string) {
        const matches = formula.matchAll(Ir.Components.ReportDesigner.ReportDesigner.regexExpressionFormula);

        for (const match of matches) {
            let queryName = match.groups.queryName;
            let fieldExpression = self.availableFields().find(x => x.queryName === queryName);
            if (fieldExpression) {
                let fieldName = `[${fieldExpression.displayNameForExpression}]`;
                formula = formula.replace(match[0], fieldName);
            }
        }

        return formula;
    }

    function validateDesigner(self: IViewModel) {
    }
}